export default function icelandicReplace(text: string): string {
  if (text !== undefined) {
    return text
      .replace(/á/g, 'a')
      .replace(/í/g, 'i')
      .replace(/æ/g, 'ae')
      .replace(/ð/g, 'd')
      .replace(/ö/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/é/g, 'e')
      .replace(/ /g, '-')
      .replace(/&/g, '-')
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/components/Shared/Icelandic/index.ts